import { Trash2 , Edit,User, Users, Unlock, Lock } from "lucide-react";
import { useState, useEffect } from "react";
import MatiereBadge from "./MatiereBadge";
const TableGroupe = ({ groupe, onEdit,cancelEditing, editedNomGroupe, setEditedNomGroupe, handleDetailGroupeClick,editingGroup,profDetail, editedProfesseur, setEditedProfesseur,
     handleUpdateGroupe, onDelete, onViewStudents }) => {
   
    // Ajouter un useEffect pour initialiser les valeurs quand on passe en mode édition

const getGroupeInitials = (nom) => {
  if (!nom) return '';
  
  // Si le nom contient des espaces, prendre les initiales (max 3)
  if (nom.includes(' ')) {
    return nom.split(' ')
      .slice(0, 3) // Maximum 3 mots
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase();
  }
  
  // Sinon, prendre les 3 premières lettres (max)
  return nom.substring(0, 3).toUpperCase();
};
 
const isEditing = editingGroup && editingGroup.id === groupe.id;

  return (
    <tr 
      className="hover:bg-blue-200 xl:text-lg text-base hover:backdrop-blur-sm transition-all duration-200 
      cursor-pointer group bg-white"
      onClick={() => onViewStudents(groupe)}
    >
      <td className="p-4">
        <div className="flex items-center gap-3">
          <div 
            className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-sky-300  
            flex items-center justify-center text-white text-xs font-bold border-4 border-white border-opacity-30">
          
            {getGroupeInitials(groupe.nom)}
          </div>
          <div className="font-semibold text-gray-800">
                 {isEditing   ? <>
        <div className="p-3">
                <input
                  type="text"
                  value={editedNomGroupe}
                  onChange={(e) => setEditedNomGroupe(e.target.value)}
                  className="w-full text-base font-semibold text-gray-800 bg-yellow-50 border-2 border-yellow-300 rounded-lg px-2 py-1 focus:outline-none focus:border-yellow-500"
                  placeholder="NOM GROUPE"

                  onClick={(e) => e.stopPropagation()}
                />
              </div>
        </>
        :
        <>
       {groupe.nom}
        </>}
            </div>
            {groupe.matiere && <MatiereBadge matiere={groupe.matiere} />}
        </div>
      </td>
      <td className="p-4">
        <span className="bg-blue-500 text-white px-2 py-1 rounded-xl text-sm font-medium">
          {groupe.niveau}
        </span>
      </td>
      <td className="p-4">
        <span className="bg-orange-500 text-white px-2 py-1 rounded-xl text-sm font-medium">
          {groupe.classes_detail.map((classe)=> classe + "  ")}
        </span>
      </td>
      <td className="p-4 text-blue-600 font-semibold">
        {groupe.eleves.length}
      </td>
      <td className="p-4 text-gray-700">
        {isEditing ? (
<select
              value={editedProfesseur || ""}
              onChange={(e) => setEditedProfesseur(e.target.value)}
              className="w-full text-base bg-yellow-50 border-2 border-yellow-300 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            >
              <option value="" disabled>Sélectionner un professeur</option>
              {profDetail && profDetail.map((prof) => (
                <option key={prof.id} value={prof.id}>
                  {prof.prenom} {prof.nom}
                </option>
              ))}
            </select>
  ) : (
    <div className="flex items-center gap-2">
      <User size={16} className="text-gray-500" />
      {groupe.professeur_nom}
    </div>
  )}
      </td>
   
      <td className="p-4">
  <span className={`px-3 py-1 rounded-xl text-sm font-medium flex w-fit items-center gap-2 ${groupe.statut ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
    {groupe.statut ? <Unlock size={16} /> : <Lock size={16} />}
    {groupe.statut ? "Déverouillé" : "Verrouillé"}
  </span>
</td>
     {isEditing ? (
          <td className="p-4">
            <div className="flex gap-2 items-center">
              <button
                className="w-7 h-7 bg-green-500 hover:bg-green-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
                onClick={(e) => {
                  e.stopPropagation();
                  handleUpdateGroupe(groupe.id);
                }}
                title="Valider"
              >
                ✓
              </button>
              <button
                className="w-7 h-7 bg-gray-500 hover:bg-gray-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
                onClick={(e) => {
                  e.stopPropagation();
                  cancelEditing();
                }}
                title="Annuler"
              >
                ✕
              </button>
            </div>
            </td>
          ) :
      <td className="p-4">
        <div className="flex gap-2 items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <button
            className="p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-all duration-200 hover:-translate-y-0.5"
            onClick={(e) => {
              e.stopPropagation();
              handleDetailGroupeClick(groupe);
            }}
            title="Voir les élèves"
          >
            <Users size={16} />
          </button>
         <button 
                onClick={(event) => onEdit(event, groupe)}
                className="p-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition-all duration-200 hover:-translate-y-0.5" 
                title="Modifier"
              >
            <Edit size={16} />
          </button>
          <button 
            className="p-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-all duration-200 hover:-translate-y-0.5"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(groupe.id);
            }}
            title="Supprimer"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </td>
}
    </tr>
  );
};

export default TableGroupe;